document.addEventListener("DOMContentLoaded", function () {

    // Get the play and pause buttons
    const playButton = document.getElementById('playButton');
    const pauseButton = document.getElementById('pauseButton');

    if (playButton && pauseButton) {
        playButton.addEventListener('click', function () {
            const videoBackground = document.querySelector('.video__player');
            const video = videoBackground.querySelector('video');
            if (video) {
                video.play();
                playButton.style.display = 'none';
                pauseButton.style.display = 'block';
            }
        });

        pauseButton.addEventListener('click', function () {
            const videoBackground = document.querySelector('.video__player');
            const video = videoBackground.querySelector('video');
            if (video) {
                video.pause();
                pauseButton.style.display = 'none';
                playButton.style.display = 'block';
            }
        });
    }
});
